import api from '@edu-fe/api'

export default {
  name: 'free',
  getData: api.create('/operation/free/columns?client=2'),
  getRadio: (courseId, pageNo, pageSize = 10) => api.create(`/course/radio/chapters?pageNo=${pageNo}&pageSize=${pageSize}&courseId=${courseId}`),
  subscribe: (status, type, courseId) => api.create(`/daily/subscribe?status=${status}&type=${type}&courseId=${courseId}`, { method: 'post' })
}
